import script from "./Checkboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./Checkboard.vue?vue&type=script&lang=ts&setup=true"

import "./Checkboard.vue?vue&type=style&index=0&id=7494636c&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7494636c"]])

export default __exports__